<template>
  <div class="profile-page" :style="portalThemeStyles">
    <TopNav />
    <SubirImagen @listo="initialize_" ref="subirimagen" />
    <div class="column-left">
      <SideNav />
    </div>
    <div class="column-right">
      <div v-if="loaded" class="profile-content">
        <section class="profile-card">
          <div class="profile-avatar">
            <div class="avatar-frame">
              <img v-if="profileImage" :src="profileImage" alt="Foto de perfil" />
              <div v-else class="avatar-fallback">{{ userInitials }}</div>
            </div>
          </div>
          <div class="profile-details">
            <h1 class="profile-name">{{ displayName }}</h1>
            <p class="profile-email">{{ userEmail }}</p>
            <div class="chip-row">
              <span class="chip chip-primary">{{ userRoleLabel }}</span>
              <span v-if="companyName" class="chip chip-secondary">{{ companyName }}</span>
            </div>
            <dl class="meta-list">
              <div>
                <dt>Teléfono</dt>
                <dd>{{ telefono || 'Sin teléfono' }}</dd>
              </div>
              <div v-if="admin_datos && admin_datos.created_at">
                <dt>Miembro desde</dt>
                <dd>{{ formatDate(admin_datos.created_at) }}</dd>
              </div>
            </dl>
          </div>
        </section>

        <section class="form-card">
          <header class="form-card-header">
            <h2>Información personal</h2>
            <p>Actualiza los datos visibles en tu cuenta</p>
          </header>
          <form class="form-card-body" @submit.prevent="guardar_datos">
            <div class="form-grid">
              <label class="field">
                <span>Nombre</span>
                <input type="text" v-model="nombre" autocomplete="given-name" />
              </label>
              <label class="field">
                <span>Apellido</span>
                <input type="text" v-model="apellido" autocomplete="family-name" />
              </label>
              <label class="field">
                <span>Correo electrónico</span>
                <input type="email" v-model="email" autocomplete="email" />
              </label>
              <label class="field">
                <span>Teléfono</span>
                <input type="text" v-model="telefono" autocomplete="tel" />
              </label>
            </div>
            <div class="form-actions">
              <button class="btn btn-std" type="submit">Guardar datos</button>
            </div>
          </form>
        </section>

        <section class="form-card password-card">
          <header class="form-card-header">
            <h2>Cambiar contraseña</h2>
            <p>Actualiza tu contraseña para mantener tu cuenta segura</p>
          </header>
          <form class="form-card-body" @submit.prevent="actualizarPassword">
            <div class="form-grid password-grid">
              <label class="field">
                <span>Contraseña actual</span>
                <input
                  type="password"
                  v-model="currentPassword"
                  autocomplete="current-password"
                  required
                />
              </label>
              <label class="field">
                <span>Nueva contraseña</span>
                <input
                  type="password"
                  v-model="newPasswordField"
                  autocomplete="new-password"
                  required
                  minlength="8"
                />
              </label>
              <label class="field">
                <span>Confirmar nueva contraseña</span>
                <input
                  type="password"
                  v-model="confirmPassword"
                  autocomplete="new-password"
                  required
                  minlength="8"
                />
              </label>
            </div>
            <div class="form-actions">
              <button
                class="btn btn-std"
                type="submit"
                :disabled="updatingPassword"
              >
                {{ updatingPassword ? 'Actualizando...' : 'Actualizar contraseña' }}
              </button>
            </div>
          </form>
        </section>
      </div>
      <div v-else class="loading-state">
        <div class="spinner-border text-secondary" role="status"></div>
        <p>Cargando perfil...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import Fuse from 'fuse.js'
import InputColorPicker from 'vue-native-color-picker'
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import SubirImagen from '@/components/SubirImagen.vue';
export default {
  name: 'HelloWorld',
  props:['id'],
  components: {
    SideNav,
    TopNav,
    SubirImagen,
    InputColorPicker,
  },
  data() {
    return {
    loaded:false,

    nombre:'',
    apellido:'',
    email:'',
    telefono:'',
    direccion:'',
    tel_prefijo:'+56',

    focused_nombre:false,
    focused_apellido:false,
    focused_email:false,
    focused_telefono:false,
    focused_direccion:false,
    seleccionando_telefono:false,

    info:{},

    banderas:[
        {arch:'cl.svg', num:'+56', nom:'Chile'},
        {arch:'ar.svg', num:'+54', nom:'Argentina'},
        {arch:'br.svg', num:'+55', nom:'Brasil'},
        {arch:'us.svg', num:'+1', nom:'Estados Unidos'},
        {arch:'co.svg', num:'+57', nom:'Colombia'},        
        {arch:'mx.svg', num:'+52', nom:'Mexico'},
        {arch:'pe.svg', num:'+51', nom:'Peru'},
        {arch:'uy.svg', num:'+598', nom:'Uruguay'},
        {arch:'bo.svg', num:'+591', nom:'Bolivia'},
    ],


     window: {
        width: 0,
        height: 0
      },

    currentPassword: '',
    newPasswordField: '',
    confirmPassword: '',
    updatingPassword: false,
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);

  },
  created(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  
    this.initialize_(this.$route.params.id);

  },

  methods:{
    ...mapActions(['initialize', 'getpro']),

    getFlagUrl(pic) {
    return require('../assets/banderas/'+pic)
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    isValidHexColor(color) {
      if (typeof color !== 'string') {
        return false;
      }
      const value = color.trim();
      return /^#?[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(value);
    },

    normalizeHexColor(color) {
      if (!this.isValidHexColor(color)) {
        return null;
      }
      let hex = color.trim().replace('#', '');
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((char) => `${char}${char}`)
          .join('');
      }
      return `#${hex.toLowerCase()}`;
    },

    adjustColor(hex, ratio) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return hex;
      }

      const clampRatio = Math.max(-1, Math.min(1, ratio));
      const integer = parseInt(normalized.slice(1), 16);
      const channels = [
        (integer >> 16) & 0xff,
        (integer >> 8) & 0xff,
        integer & 0xff,
      ];

      const adjustChannel = (channel) => {
        const delta = clampRatio >= 0 ? (255 - channel) * clampRatio : channel * clampRatio;
        return Math.max(0, Math.min(255, Math.round(channel + delta)));
      };

      const [r, g, b] = channels.map(adjustChannel);
      const toHex = (channel) => channel.toString(16).padStart(2, '0');

      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },

    hexToRgba(hex, alpha = 1) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) {
        return `rgba(255, 140, 0, ${alpha})`;
      }
      const integer = parseInt(normalized.slice(1), 16);
      const r = (integer >> 16) & 0xff;
      const g = (integer >> 8) & 0xff;
      const b = integer & 0xff;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
   
    
      initialize_(pid){
      if (typeof(this.$route.params.id === 'number'))
      {
        this.loaded = false;
        this.nombre = this.admin_datos.nombre
        this.apellido = this.admin_datos.apellido
        this.email = this.admin_datos.email
        this.telefono = this.admin_datos.telefono
        if (this.admin_datos && this.admin_datos.user_type) {
          this.info = {}
          this.loaded = true;
          return
        }
        axios.post(window.hostname+'api/profesional/init_modificar_perfil', 
        {id: pid})
        .then(response => 
        {
            this.loaded = true;
             this.info  = response.data
        })

        .catch(e=>{
            this.loaded = true;
            console.log("Error al cargar...")
        })
      }
    },
      guardar_datos(){
        if (this.admin_datos && this.admin_datos.user_type) {
          axios.post(window.hostname+'api/admin/update_profile',
          {nombre: this.nombre,
          apellido: this.apellido,
          email: this.email,
          telefono: this.telefono})
          .then(() =>
          {
            this.loaded = true;
            this.$notify({
              group: 'foos',
              title: 'Â¡Ã‰xito!',
              type: 'success',
              text: 'Â¡Se han actualizado los datos!',
            });
            this.getpro();
          })

          .catch(() => {
            this.loaded = true;
          })
          return
        }
        axios.post(window.hostname+'api/profesional/modificar_datos',
        {nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        telefono: this.telefono})
        .then(response => 
        {
          this.loaded = true;
          this.$notify({
            group: 'foos',
            title: '¡Éxito!',
            type: 'success',
            text: '¡Se han actualizado los datos!',
          });
          this.getpro();
        })

        .catch(e=>{
            this.loaded = true;

        })

    },
    actualizarPassword () {
      if (this.updatingPassword) {
        return
      }

      const current = (this.currentPassword || '').trim()
      const nextPassword = (this.newPasswordField || '').trim()
      const confirmation = (this.confirmPassword || '').trim()

      if (!current || !nextPassword || !confirmation) {
        this.$notify({
          group: 'foos',
          title: 'Atención',
          type: 'warn',
          text: 'Debes completar todos los campos para cambiar la contraseña.',
        })
        return
      }

      if (nextPassword.length < 8) {
        this.$notify({
          group: 'foos',
          title: 'Atención',
          type: 'warn',
          text: 'La nueva contraseña debe tener al menos 8 caracteres.',
        })
        return
      }

      if (nextPassword !== confirmation) {
        this.$notify({
          group: 'foos',
          title: 'Atención',
          type: 'warn',
          text: 'La confirmación debe coincidir con la nueva contraseña.',
        })
        return
      }

      if (current === nextPassword) {
        this.$notify({
          group: 'foos',
          title: 'Atención',
          type: 'warn',
          text: 'La nueva contraseña debe ser diferente a la actual.',
        })
        return
      }

      this.updatingPassword = true

      axios.post(window.hostname + 'api/admin/update_password', {
        current_password: current,
        new_password: nextPassword,
      })
        .then(() => {
          this.$notify({
            group: 'foos',
            title: '¡Éxito!',
            type: 'success',
            text: '¡Tu contraseña se actualizó correctamente!',
          })
          this.currentPassword = ''
          this.newPasswordField = ''
          this.confirmPassword = ''
        })
        .catch((error) => {
          const message = (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'Ocurrió un error al actualizar la contraseña.'
          this.$notify({
            group: 'foos',
            title: 'Error',
            type: 'error',
            text: message,
          })
        })
        .finally(() => {
          this.updatingPassword = false
        })
    },
    formatDate (value) {
      if (!value) {
        return ''
      }
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return value
      }
      return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'long'
      })
    }
  },
  computed:{
    ...mapGetters(['admin_datos']),
    tenantAtributos() {
      if (!this.admin_datos) {
        return null;
      }
      if (this.admin_datos.user_type === 'property_manager') {
        return this.admin_datos.empresa && this.admin_datos.empresa.atributos
          ? this.admin_datos.empresa.atributos
          : null;
      }
      if (this.admin_datos.user_type === 'lead_partner') {
        return this.admin_datos.lead_partner && this.admin_datos.lead_partner.atributos
          ? this.admin_datos.lead_partner.atributos
          : null;
      }
      return null;
    },
    tenantBrandColor() {
      const atributos = this.tenantAtributos;
      if (!atributos) {
        return null;
      }

      const color = atributos && atributos.color ? atributos.color : null;

      if (!this.isValidHexColor(color)) {
        return null;
      }

      return this.normalizeHexColor(color);
    },
    portalThemeStyles() {
      if (!this.tenantBrandColor) {
        return {};
      }

      const base = this.tenantBrandColor;

      return {
        '--pm-cta-solid': base,
        '--pm-cta-solid-hover': this.adjustColor(base, -0.12),
        '--pm-cta-shadow': `0 12px 28px ${this.hexToRgba(base, 0.22)}`,
        '--pm-cta-shadow-hover': `0 16px 34px ${this.hexToRgba(base, 0.28)}`,
      };
    },
    profileImage () {
      return this.info && this.info.link ? this.info.link : ''
    },
    displayName () {
      const nombre = this.nombre ? this.nombre.trim() : ''
      const apellido = this.apellido ? this.apellido.trim() : ''
      const fullName = [nombre, apellido].filter(Boolean).join(' ')
      return fullName || this.userEmail || 'Usuario'
    },
    userEmail () {
      if (this.email && this.email.trim() !== '') {
        return this.email
      }
      return this.admin_datos && this.admin_datos.email ? this.admin_datos.email : ''
    },
    userInitials () {
      const nombre = this.nombre ? this.nombre.trim().charAt(0) : ''
      const apellido = this.apellido ? this.apellido.trim().charAt(0) : ''
      const initials = `${nombre}${apellido}`.replace(/\s+/g, '')
      if (initials) {
        return initials.toUpperCase()
      }
      if (this.userEmail) {
        return this.userEmail.charAt(0).toUpperCase()
      }
      return 'US'
    },
    userRoleLabel () {
      if (!this.admin_datos) {
        return ''
      }
      if (this.admin_datos.user_type === 'property_manager') {
        return 'Administrador de propiedades'
      }
      if (this.admin_datos.user_type === 'lead_partner') {
        return 'Lead partner'
      }
      if (this.admin_datos.superadmin === 1 || this.admin_datos.superadmin === true) {
        return 'Superadministrador'
      }
      return 'Administrador'
    },
    companyName () {
      const tenant = this.admin_datos && this.admin_datos.user_type === 'lead_partner'
        ? this.admin_datos.lead_partner
        : this.admin_datos && this.admin_datos.empresa
          ? this.admin_datos.empresa
          : null
      if (!tenant) {
        return ''
      }
      return (
        tenant.nombre ||
        tenant.nombre_fantasia ||
        tenant.razon_social ||
        (tenant.atributos && (tenant.atributos.nombre || tenant.atributos.nombre_fantasia)) ||
        ''
      )
    },

    viendoSemana: function(){
      var o;
      var f = [new Date(this.viendoAño, this.viendoMes-1, this.desdeD.getDate())];
      var ret = [this.desdeD.getDate()]
      for (var i = 1; i < 7; i++)
      {
        o = new Date(f[i-1].getFullYear(), f[i-1].getMonth(), f[i-1].getDate())
        o.setDate(o.getDate() + 1)
        f.push(o)
        ret.push(o.getDate())
      }

      return ret;
     
    },
    horas: function(){
      let h = []
      for(var i = 0; i<this.profesional.horarios.length; i++)
      {
        for(var j = 0; j < this.profesional.horarios[i].ordenes.length; j++)
        {

          h.push(this.profesional.horarios[i].ordenes[j])
      
        }

      }
      return h;

    },
    horaMin: function(){
      var min = 360;
      for(var i = 0; i<this.profesional.horarios.length; i++)
      {
        for(var j = 0; j < this.profesional.horarios[i].ordenes.length; j++)
        {
          if (this.profesional.horarios[i].ordenes[j].desde < min)
          {
            min = this.profesional.horarios[i].ordenes[j].desde
          }
        }

      }
      return min
    },

    horaMax: function(){
      var max = 1080;
      for(var i = 0; i<this.profesional.horarios.length; i++)
      {
        for(var j = 0; j < this.profesional.horarios[i].ordenes.length; j++)
        {
          if (this.profesional.horarios[i].ordenes[j].desde > max)
          {
            max = this.profesional.horarios[i].ordenes[j].desde
          }
        }

      }
      return max
    },
  },
  mounted() {
    this.fComunas = new Fuse(this.comunas, {  keys: ['Nombre']})
  },
  watch:{
    comunas_buscadas(val){
      this.resultado_fuse_comuna = this.fComunas.search(val)

    },
    profesional(){
      this.editando_categorias = []
      for(var i = 0; i < this.categorias.length; i++){
        this.editando_categorias.push({id:this.categorias[i].id, nombre:this.categorias[i].nombre, puede:this.profesional.categorias.some(x=>{return x == this.categorias[i].id})})
      }
    }
  }

}
</script>
<style scoped>
.profile-page {
  text-align: left;
  background: #e2e8f0;
  min-height: 100vh;
  --pm-cta-solid: #ff8c00;
  --pm-cta-solid-hover: #ffac46;
  --pm-cta-shadow: 0 12px 24px rgba(255, 140, 0, 0.22);
  --pm-cta-shadow-hover: 0 16px 30px rgba(255, 140, 0, 0.28);
}

.column-left {
  float: left;
}

.column-right {
  background: transparent;
  padding: 96px 48px 48px 280px;
  min-height: 100vh;
  box-sizing: border-box;
}

.profile-content {
  width: 100%;
  max-width: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.profile-card,
.form-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  padding: 32px;
}

.profile-card {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: flex-start;
}

.profile-avatar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.avatar-frame {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 30px rgba(14, 165, 233, 0.25);
}

.avatar-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback {
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.05em;
}

.profile-details {
  flex: 1 1 0;
  min-width: 0;
}

.profile-name {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.profile-email {
  font-size: 15px;
  color: #64748b;
  margin-bottom: 16px;
  word-break: break-word;
}

.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: normal;
  word-break: break-word;
}

.chip-primary {
  background: rgba(14, 165, 233, 0.15);
  color: #0369a1;
}

.chip-secondary {
  background: rgba(15, 23, 42, 0.08);
  color: #0f172a;
}

.meta-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}

.meta-list dt {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 4px;
}

.meta-list dd {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.form-card-header h2 {
  font-size: 22px;
  color: #0f172a;
  margin-bottom: 6px;
}

.form-card-header p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.form-card-body {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px 24px;
}

.password-grid {
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: #475569;
}

.field span {
  font-weight: 600;
  letter-spacing: 0.01em;
}

.field input {
  border: 1px solid rgba(148, 163, 184, 0.6);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field input:focus {
  outline: none;
  border-color: rgba(14, 165, 233, 0.9);
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.profile-page .btn-std {
  background: var(--pm-cta-solid, #ff8c00) !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 12px;
  padding: 12px 20px;
  font-weight: 600;
  box-shadow: var(--pm-cta-shadow, 0 12px 24px rgba(255, 140, 0, 0.22));
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.profile-page .btn-std:hover:not(:disabled) {
  background: var(--pm-cta-solid-hover, #ffac46) !important;
  box-shadow: var(--pm-cta-shadow-hover, 0 16px 30px rgba(255, 140, 0, 0.28));
  transform: translateY(-1px);
}

.profile-page .btn-std:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 320px;
  color: #64748b;
}

.loading-state p {
  margin: 0;
}

@media (max-width: 1024px) {
  .column-right {
    padding: 88px 24px 32px 240px;
  }
}

@media (max-width: 800px) {
  .column-right {
    padding: 88px 20px 32px 20px;
  }

  .profile-card,
  .form-card {
    padding: 24px;
  }
}

@media (max-width: 540px) {
  .avatar-frame {
    width: 120px;
    height: 120px;
  }

  .profile-name {
    font-size: 24px;
  }
}
</style>
